import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { URLSearchParams, Response } from '@angular/http';
import { Api } from './api.service';
import { PAGINATION_NUMBER } from './constants.service';
import { Subscription, ListResult, User, SubscriptionHistory } from '../entities/index';
import { Log } from '../utils/index';

@Injectable()
export class SubscriptionService {
  constructor(protected http: Api) {
  }

  @Log('green')
  get(id: number): Observable<Subscription> {
    return this.http.get(`subscription/${id}`);
  }

  @Log('green')
  put(id: number, options: string[]): Observable<Subscription> {
    return this.http.put(`subscription/${id}`, {options: options});
  }

  @Log('green')
  put_modify_next_charge_at(id: number, next_charge_at: string): Observable<Subscription> {
    return this.http.put(`subscription/${id}`, {"next_charge_at": next_charge_at});
  }

  @Log('green')
  reactivate(subscription: Subscription): Observable<Response> {
    const id = subscription.id;
    return this.http.delete(`subscription/${id}/cancel`, {});
  }

  @Log('green')
  cancel(subscription: Subscription): Observable<Subscription> {
    const id = subscription.id;
    return this.http.post(`subscription/${id}/cancel`, {});
  }


  @Log('green')
  cancel_immediately(subscription: Subscription): Observable<Subscription> {
    const id = subscription.id;
    return this.http.post(`subscription/${id}/cancel-immediately`, {});
  }

  @Log('green')
  list(search: string = null, page: number = 1, limit: number = PAGINATION_NUMBER): Observable<ListResult<Subscription>> {
    const params = new URLSearchParams();
    if (search) {
      params.set('search', String(search));
    }
    if (page) {
      params.set('page', String(page));
    }
    if (limit) {
      params.set('limit', String(limit));
    }

    return this.http.get('subscription', {search: params});
  }

  @Log('green')
  listByUser(user: User): Observable<Subscription[]> {
    const params = new URLSearchParams();
    params.set('user_id', String(user.id));
    params.set('limit', '1000');
    return this.http.get('subscription', {search: params})
      .map((res: ListResult<Subscription>) => {
        return res.items;
      });
  }

  @Log('green')
  subsImportFile(id: number): Observable<string> {
    return this.http.downloadFile(`/subscriptionpayment/${id}/invoice`, 'application/pdf');
  }

  @Log('green')
  optionImportFile(id: number): Observable<string> {
    return this.http.downloadFile(`/optionpayment/${id}/invoice`, 'application/pdf');
  }

  @Log('green')
  listSubscriptionHistory(id: number): Observable<SubscriptionHistory[]> {
    return this.http.get(`subscription/${id}/history`)
      .map((res: ListResult<SubscriptionHistory>) => {
        return res.items;
      });
  }
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/services/subscription.service.ts